module.exports = __webpack_public_path__ + "static/media/boy_talking.6268911f.gif";